export default "__VITE_ASSET__13de17ea__"